import { playerDisplayName } from "./PlayerDisplayNameLink";
/** A summary-only player (someone off the roster but in a match) carries a
 * precomputed `name`; a full Player/TeamMembershipPlayer derives it from `user`. */
export const isPlayerSummary = (player) => !("user" in player);
/** A "real athlete": a player backed by a registered user account (not a guest/
 * external placeholder, whose `user` is null, and not a summary-only player,
 * which has no `user` at all). Drives the verified ring/badge on avatars. */
export const isRegisteredPlayer = (player) => "user" in player && player.user != null;
/** Display name for either a full player or a summary-only player. */
export const playerSummaryName = (player) => isPlayerSummary(player) ? player.name ?? "" : playerDisplayName(player);
export const findPlayerById = (players) => {
    return (id) => {
        return players.find((player) => player.id === id);
    };
};
